import { useLocation } from 'react-router-dom';
import { LetterEasySendDeliveryStats } from 'assets/js/pages/engage/letters/LetterEasySendDeliveryStats';
import { LetterEasySendOrderDetails } from 'assets/js/pages/engage/letters/LetterEasySendOrderDetails';
import { LetterEasySendTracking } from 'assets/js/pages/engage/letters/LetterEasySendTracking';
import { LetterPreview } from 'assets/js/pages/engage/letters/LetterPreview';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import * as Breadcrumbs from 'components/breadcrumbs';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LetterDetailsEasySend = () => {
    const location = useLocation();
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();

    return (
        <div className={'mx-auto flex w-full max-w-screen-lg flex-col gap-4'}>
            <Breadcrumbs.Root>
                <Breadcrumbs.Crumb to={`/accounts/${accountId}/engage/letters`}>
                    Mailings
                </Breadcrumbs.Crumb>
                <Breadcrumbs.Crumb to={location.pathname}>
                    {letter?.internal_name}
                </Breadcrumbs.Crumb>
            </Breadcrumbs.Root>
            <LetterEasySendOrderDetails />
            <LetterEasySendDeliveryStats />
            <LetterEasySendTracking />
            <LetterPreview />
        </div>
    );
};

export { LetterDetailsEasySend };
